/* tslint:disable:max-classes-per-file */
import { Action } from '@ngrx/store';

import {
  ILoginApiResponseSuccess,
  ILoginApiResponseFailure
} from '../interfaces/login-api-response.interface';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';
export const EXPIRE_LOGIN = 'EXPIRE_LOGIN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';

export class LoginAction implements Action {
  public readonly type = LOGIN;

  constructor(public payload: { userName: string; password: string }) {}
}

export class LoginSuccessAction implements Action {
  public readonly type = LOGIN_SUCCESS;

  constructor(public payload: ILoginApiResponseSuccess) {}
}

export class SetRedirectUrlAction implements Action {
  public readonly type = SET_REDIRECT_URL;

  constructor(public payload: string) {}
}

export class LoginFailedAction implements Action {
  public readonly type = LOGIN_FAILED;

  constructor(public payload: ILoginApiResponseFailure) {}
}

export class LogoutAction implements Action {
  public readonly type = LOGOUT;
}

export class LogoutSuccessAction implements Action {
  public readonly type = LOGOUT_SUCCESS;
}

export class LogoutFailedAction implements Action {
  public readonly type = LOGOUT_FAILED;
}

export class ExpireLoginAction implements Action {
  public readonly type = EXPIRE_LOGIN;
}

export class RefreshTokenAction implements Action {
  public readonly type = REFRESH_TOKEN;

  constructor(public payload: { token: string }) {}
}

export class RefreshTokenActionSuccess implements Action {
  public readonly type = REFRESH_TOKEN_SUCCESS;

  constructor(public payload: ILoginApiResponseSuccess) {}
}

export type Actions =
  | LoginAction
  | LoginSuccessAction
  | LoginFailedAction
  | SetRedirectUrlAction
  | LogoutAction
  | LogoutSuccessAction
  | LogoutFailedAction
  | ExpireLoginAction
  | RefreshTokenAction
  | RefreshTokenActionSuccess;
